__turbopack_context__.v({
  "back": "index-module__lomGoW__back",
  "context": "index-module__lomGoW__context",
  "title": "index-module__lomGoW__title",
});
